// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"54532508","787":"3f0d1cb9","845":"b6339377"}[chunkId] + ".chunk.js";
};